import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { statusChecksQueryKeys } from 'queries/status-checks/query-keys'

import type { StatusCheck } from 'types/api/status-checks/status-check'

async function fetchStatusChecks({
  queryKey
}: QueryFunctionContext<ReturnType<typeof statusChecksQueryKeys.all>>) {
  return await fetchQueryData<StatusCheck[]>(getEndpointWithParams(...queryKey))
}

export function useGetStatusChecks<TData = StatusCheck[]>(
  options?: UseQueryOptions<StatusCheck[], AxiosError, TData>
) {
  const { currentTeamId } = useAuth()

  return useQuery<StatusCheck[], AxiosError, TData>({
    ...options,
    queryKey: statusChecksQueryKeys.all(currentTeamId),
    queryFn: fetchStatusChecks
  })
}
